import React from "react";
import {GalleryElement} from "./galleryElement";
import {CardBody, CardTitle, Row} from "reactstrap";
import {GALLERY_HEADER} from "../i18n/i18n";
import {ButtonRefresh} from "../buttons/buttonsActions";

export const MediaGallery = (props)  => {
    const items = props.items;

    const resetControl = () => {
        props.refreshList();
    }

    const sendDelete = (mediaId) => {
        props.sendDelete(mediaId);
    }

    const sendEdit = (mediaId) => {
        props.sendEdit(mediaId);
    }

    const getGalleryArray = (items, sendDelete, sendEdit) => {
        return items.map((item ) => {
            return (
                <GalleryElement item={item} sendDelete={sendDelete} sendEdit={sendEdit} className={''} />
            );
        })
    }

    return (
        <div>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-image mr-2"/>
                {GALLERY_HEADER}
                <div className="float-right">
                    <ButtonRefresh onClick={() => resetControl()} />
                </div>
            </CardTitle>
            <CardBody>
                <Row>
                    {
                        getGalleryArray(items, sendDelete, sendEdit)
                    }
                </Row>
            </CardBody>
        </div>
    );
};

